import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaClock } from "react-icons/fa";

function CourseslevellistPage() {
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [courseTitles, setCourseTitles] = useState([]);

    const [selectedTitle, setSelectedTitle] = useState("all");
    const [selectedLevel, setSelectedLevel] = useState("all");
    const [selectedDuration, setSelectedDuration] = useState("all");

    const location = useLocation();
    const selectedCourseTitle = location.state?.selectedCourseTitle || null;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get(`https://api.itrain.io/courses/getAllCourses`);
                const data = response.data;
                setCourses(data.courses);

                // Extract unique course titles
                const titles = ["all", ...new Set(data.courses.map(course => course.courseTitle))];
                setCourseTitles(titles);

                if (selectedCourseTitle) {
                    setSelectedTitle(selectedCourseTitle);
                    const filtered = data.courses.filter(course => course.courseTitle === selectedCourseTitle);
                    setFilteredCourses(filtered);
                } else {
                    setFilteredCourses(data.courses);
                }
            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        };

        fetchCourses();
    }, [selectedCourseTitle]);

    const handleViewDetails = (courseId) => {
        navigate(`/course-details?id=${courseId}`);
    };

    const handleTitleChange = (e) => {
        setSelectedTitle(e.target.value);
    };

    const handleLevelChange = (e) => {
        setSelectedLevel(e.target.value);
    };

    const handleDurationChange = (e) => {
        setSelectedDuration(e.target.value);
    };

    const filteredResults = courses.filter(course => {
        const matchesTitle = selectedTitle === "all" || course.courseTitle === selectedTitle;
        const matchesLevel = selectedLevel === "all" || course.courseLevel === selectedLevel;
        const matchesDuration = selectedDuration === "all" || course.courseDuration === selectedDuration;
        return matchesTitle && matchesLevel && matchesDuration;
    });
    return (
        <section className="service-section bg-grey padding">
            <div className="map-pattern" />
            <div className="container">
                <div className="section-heading mb-30">
                    <h2>Courses</h2>
                </div>

                {/* Filters Section */}
                <div className="filters mb-4" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                    {/* Course Title Filter */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <label style={{ fontSize: '14px', color: '#FF001E', marginBottom: '5px',  display: 'inline-block',
                                                    padding:"1px",
                                                    paddingLeft:"10px",
                                                    paddingRight:"10px",
                                                      borderRadius: '10px',
                                                      backgroundColor: '#FF001E',
                                                        color: '#fff', }} > <b>Select Course</b></label>
                        <select
                            value={selectedTitle}
                            onChange={handleTitleChange}
                            style={{
                                width: '200px',
                                padding: '8px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                fontSize: '14px',
                                color: '#333',
                                outline: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            {courseTitles.map((title, index) => (
                                <option key={index} value={title}>{title}</option>
                            ))}
                        </select>
                    </div>

                    {/* Level Filter */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <label style={{ fontSize: '14px', color: '#FF001E', marginBottom: '5px', display: 'inline-block',
                                                        padding:"1px",
                                                        paddingLeft:"10px",
                                                        paddingRight:"10px",
                                                          borderRadius: '10px',
                                                          backgroundColor: '#FF001E',
                                                        color: '#fff', }}> <b>Select Level</b> </label>
                        <select
                            value={selectedLevel}
                            onChange={handleLevelChange}
                            style={{
                                width: '200px',
                                padding: '8px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                fontSize: '14px',
                                color: '#333',
                                outline: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            <option value="all">All Levels</option>
                            <option value="Beginner">Beginner</option>
                            <option value="Intermediate">Intermediate</option>
                            <option value="Advanced">Advanced</option>
                        </select>
                    </div>

                    {/* Duration Filter */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <label style={{ fontSize: '14px', color: '#FF001E', marginBottom: '5px' , display: 'inline-block',
                                                      padding:"1px",
                                                      paddingLeft:"10px",
                                                      paddingRight:"10px",
                                                        borderRadius: '10px',
                                                        backgroundColor: '#FF001E',
                                                        color: '#fff',}}><b>Select Schedule</b></label>
                        <select
                            value={selectedDuration}
                            onChange={handleDurationChange}
                            style={{
                                width: '200px',
                                padding: '8px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                fontSize: '14px',
                                color: '#333',
                                outline: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            <option value="all">All Durations</option>
                            <option value="Week Days">Week Days</option>
                            <option value="Week End">Week End</option>
                        </select>
                    </div>
                </div>

                <div className="row gy-4">
                    {filteredResults.length > 0 &&
                        filteredResults.map((course, index) => (
                            <div className="col-lg-4 col-md-6" key={index}>
                                <div
                                    className="service-item wow fade-in-bottom"
                                    data-wow-delay="100ms"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%',
                                        minHeight: '350px',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <div className="service-thumb">
                                        <img
                                            src={course.courseThumbnail}
                                            alt="thumb"
                                            style={{
                                                width: '100%',
                                                height: '200px',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                    <div
                                        className="service-content"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            flexGrow: 1,
                                            padding: '15px',
                                        }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h3 style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <a href={course.link}>{course.courseTitle}</a>
                                                </h3>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                                <span
                                                    className="text-13 py-2 px-10 rounded-pill"
                                                    style={{
                                                        display: 'inline-block',
                                                        padding: '10px',
                                                        borderRadius: '10px',
                                                        backgroundColor: '#FF001E',
                                                        color: '#fff',
                                                    }}
                                                >
                                                    {course.courseCategory}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="d-flex flex-column py-5" style={{ gap: '10px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <span style={{ fontSize: '14px', color: '#6c757d', fontWeight: 'bold' }}>
                                                    {course.courseLevel} Level
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <FaClock />
                                                <span style={{ fontSize: '14px', color: '#6c757d' }}>
                                                    {course.courseDuration ? course.courseDuration : 'Duration not available'} Course
                                                </span>
                                            </div>
                                        </div>

                                        <button onClick={() => handleViewDetails(course._id)} className="read-more" style={{ backgroundColor: '#FF001E', color: '#fff', border: 'none', padding: '10px', borderRadius: '5px' }}>
                                            View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                     }
                </div>
            </div>
        </section>
    );
}

export default CourseslevellistPage;
